import axios from "axios";
import { getCorrelationId } from "../utils/correlation-id";
import { getEnvVar } from "../utils/get-env";
import { createAuthHeader, isValidTokenFormat } from "../utils/auth-headers";
import { store } from "../redux/store";
import { selectCurrentCompany } from "../redux/features/user/selectors/userState.selectors";

const baseURL =
  process.env.NODE_ENV === "local"
    ? "http://localhost:3334"
    : getEnvVar("REACT_APP_PAGE_BUILDER_URL");

export const gatewayPageBuilder = axios.create({
  baseURL,
  timeout: 90000,
  headers: {
    "x-correlation-id": getCorrelationId(),
  },
});

gatewayPageBuilder.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("token");
    const state = store.getState();
    const company = selectCurrentCompany(state);
    const companyId = company?.id;

    if (companyId) {
      config.headers["x-company-id"] = String(companyId);
    }

    config.headers["x-correlation-id"] = getCorrelationId();

    if (token && isValidTokenFormat(token)) {
      Object.assign(config.headers, createAuthHeader(token));
    }

    return config;
  },
  (error) => Promise.reject(error),
);